import{authorityApi}from"./api";
import{runPrfCeremony}from"./webauthn";

type AuthorityUnlockOptions={
  ceremony_id?:unknown;
  publicKey?:unknown;
};

export async function unlockSecurityAuthority():Promise<void>{
  const options=(
    await authorityApi.unlockOptions()
  ) as AuthorityUnlockOptions;

  if(
    typeof options.ceremony_id!=="string"
    ||!options.publicKey
  ){
    throw new Error(
      "Security Authority passkey ceremony is unavailable."
    );
  }

  const proof=await runPrfCeremony(
    options.ceremony_id,
    options.publicKey,
  );

  await authorityApi.unlockVerify(proof);
}
